import { render } from "./OpenPdf.vue?vue&type=template&id=373c4c94&scoped=true"
import script from "./OpenPdf.vue?vue&type=script&lang=js"
export * from "./OpenPdf.vue?vue&type=script&lang=js"

import "./OpenPdf.vue?vue&type=style&index=0&id=373c4c94&lang=scss&scoped=true"

import exportComponent from "/Users/maguilar/Dev/repos/garantias-transelec/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373c4c94"]])

export default __exports__